import { ResponsiveContainer, AreaChart, Area, XAxis, YAxis, Tooltip, CartesianGrid } from "recharts";
import { Panel } from "@/components/common";
import { fmt, ldnTime, cur } from "@/lib/api";

export function EquityCurve({ points, title = "Equity curve", testid = "equity-curve" }) {
  const data = (points || []).map((p, i) => ({ i, equity: p.equity, label: p.t ? ldnTime(p.t) : "Start" }));
  return (
    <Panel title={title} testid={testid}>
      {data.length < 2 ? (
        <p className="text-sm text-slate-500">The curve appears after the first closed trade.</p>
      ) : (
        <div className="h-64">
          <ResponsiveContainer>
            <AreaChart data={data}>
              <defs>
                <linearGradient id="eqG" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="#10B981" stopOpacity={0.35} /><stop offset="100%" stopColor="#10B981" stopOpacity={0} /></linearGradient>
              </defs>
              <CartesianGrid stroke="rgba(255,255,255,0.06)" vertical={false} />
              <XAxis dataKey="label" tick={{ fill: "#64748B", fontSize: 10 }} minTickGap={40} />
              <YAxis domain={["auto", "auto"]} tick={{ fill: "#64748B", fontSize: 10 }} width={70} tickFormatter={(v) => fmt(v, 0)} />
              <Tooltip contentStyle={{ background: "#0F172A", border: "1px solid #1E293B", fontSize: 12 }} formatter={(v) => [`${cur()}${fmt(v)}`, "Equity"]} />
              <Area type="monotone" dataKey="equity" stroke="#10B981" strokeWidth={2} fill="url(#eqG)" />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      )}
    </Panel>
  );
}
